export const GET_CARD = "GET_CARD";
export const SET_CUSTOM_FIELDS = "SET_CUSTOM_FIELDS";
export const SET_CUSTOM_FIELDS_CLIENT = "SET_CUSTOM_FIELDS_CLIENT";
export const SET_CUSTOM_FIELDS_PRODUCT = "SET_CUSTOM_FIELDS_PRODUCT";
export const SET_CUSTOM_FIELDS_COMPANY = "SET_CUSTOM_FIELDS_COMPANY";
export const SET_CUSTOM_FIELDS_CONTRACT = "SET_CUSTOM_FIELDS_CONTRACT";
